export default __webpack_public_path__ + "static/media/logo-fractured.83822b4f.png";